import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { WebPageSchema, BreadcrumbSchema } from '../components/SEOStructuredData';
import { Container, Title, Text, List } from '@mantine/core';
import classes from './Privacy.module.css';

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbItems = [
    { name: 'Home', url: 'https://optifyne.com/' },
    { name: 'Privacy Policy', url: 'https://optifyne.com/privacy' }
  ];

  return (
    <>
      <Helmet>
        <title>Privacy Policy - Optifyne</title>
        <meta name="description" content="Read Optifyne's Privacy Policy to understand how we collect, use, and protect your personal information." />
      </Helmet>
      <WebPageSchema 
        title="Privacy Policy - Optifyne"
        description="Read Optifyne's Privacy Policy to understand how we collect, use, and protect your personal information."
        url="https://optifyne.com/privacy"
      />
      <BreadcrumbSchema items={breadcrumbItems} />
    <div className={classes.wrapper}>
      <Container size="md" className={classes.inner}>
        <Title order={1} className={classes.title}>Privacy Policy</Title>
        
        <section className={classes.section}>
          <Title order={2}>1. Information We Collect</Title>
          <Text>
            We collect information that you provide directly to us when using our services. This may include:
          </Text>
          <List mt="md">
            <List.Item>Contact information (name, email, phone number)</List.Item>
            <List.Item>Company information</List.Item>
            <List.Item>Usage data and analytics</List.Item>
          </List>
        </section>

        <section className={classes.section}>
          <Title order={2}>2. How We Use Your Information</Title>
          <Text>
            We use the information we collect to:
          </Text>
          <List mt="md">
            <List.Item>Provide and maintain our services</List.Item>
            <List.Item>Improve and personalise your experience</List.Item>
            <List.Item>Communicate with you about our services</List.Item>
            <List.Item>Comply with legal obligations</List.Item>
          </List>
        </section>

        <section className={classes.section}>
          <Title order={2}>3. Information Sharing</Title>
          <Text>
            We do not sell or rent your personal information to third parties. We may share your
            information with trusted service providers who assist us in operating our website,
            conducting our business, or servicing you.
          </Text>
        </section>

        <section className={classes.section}>
          <Title order={2}>4. Data Security</Title>
          <Text>
            We implement appropriate technical and organisational security measures to protect your
            personal information. However, no method of transmission over the Internet or electronic
            storage is 100% secure.
          </Text>
        </section>

        <section className={classes.section}>
          <Title order={2}>5. Your Rights</Title>
          <Text>
            You have the right to:
          </Text>
          <List mt="md">
            <List.Item>Access your personal information</List.Item>
            <List.Item>Correct inaccurate information</List.Item>
            <List.Item>Request deletion of your information</List.Item>
            <List.Item>Object to processing of your information</List.Item>
          </List>
        </section>

        <section className={classes.section}>
          <Title order={2}>6. Contact Us</Title>
          <Text>
            If you have any questions about this Privacy Policy, please contact us at privacy@optifyne.com
          </Text>
        </section>
      </Container>
    </div>
    </>
  );
}
